import { FormControl, FormGroup } from '@angular/forms';
import { maxLengthValidator } from '@common/helpers';
import { AswValidators } from '@lib/helpers';

export const createAddReservationReservationNumberForm = () => {
  return new FormGroup({
    reservationNumber: new FormControl<string | null>(null, {
      validators: [
        AswValidators.required({
          errorMsgId: 'E0001',
          params: {
            key: 0,
            value: 'label.recLoc',
          },
        }),
        AswValidators.alphaNumeric({
          errorMsgId: 'E0005',
          params: {
            key: 0,
            value: 'label.recLoc',
          },
        }),
        AswValidators.lengths({
          fixed: 6,
          errorMsgId: 'E0009',
          params: [
            {
              key: 0,
              value: 'label.recLoc',
            },
            {
              key: 1,
              value: 6,
              dontTranslate: false,
            },
          ],
        }),
      ],
    }),
    firstName: new FormControl<string | null>(null, {
      validators: [
        AswValidators.required({
          errorMsgId: 'E0001',
          params: {
            key: 0,
            value: 'label.firstName',
          },
        }),
        AswValidators.alphaSpace({
          errorMsgId: 'E0004',
          params: {
            key: 0,
            value: 'label.firstName',
          },
        }),
        maxLengthValidator({
          max: 55,
          errorMsgId: 'E0013',
          params: [
            {
              key: 0,
              value: 'label.firstName',
            },
            {
              key: 1,
              value: 55,
            },
          ],
        }),
      ],
    }),
    lastName: new FormControl<string | null>(null, {
      validators: [
        AswValidators.required({
          errorMsgId: 'E0001',
          params: {
            key: 0,
            value: 'label.lastName',
          },
        }),
        AswValidators.alphaSpace({
          errorMsgId: 'E0004',
          params: {
            key: 0,
            value: 'label.lastName',
          },
        }),
        AswValidators.lengths({
          min: 2,
          errorMsgId: 'E0484',
        }),
        maxLengthValidator({
          errorMsgId: 'E0013',
          max: 55,
          params: [
            {
              key: 0,
              value: 'label.lastName',
            },
            {
              key: 1,
              value: 55,
            },
          ],
        }),
      ],
    }),
  });
};

export const createAddReservationEticketNumberForm = () => {
  return new FormGroup({
    ticketNumber: new FormControl<string | null>(null, {
      validators: [
        AswValidators.required({
          errorMsgId: 'E0001',
          params: {
            key: 0,
            value: 'label.eTicketNumber',
          },
        }),
        AswValidators.numeric({
          errorMsgId: 'E0003',
          params: {
            key: 0,
            value: 'label.eTicketNumber',
          },
        }),
        AswValidators.lengths({
          fixed: 13,
          errorMsgId: 'E0009',
          params: [
            {
              key: 0,
              value: 'label.eTicketNumber',
            },
            {
              key: 1,
              value: 13,
              dontTranslate: true,
            },
          ],
        }),
      ],
    }),
    firstName: new FormControl<string | null>(null, {
      validators: [
        AswValidators.required({
          errorMsgId: 'E0001',
          params: {
            key: 0,
            value: 'label.firstName',
          },
        }),
        AswValidators.alphaSpace({
          errorMsgId: 'E0004',
          params: {
            key: 0,
            value: 'label.firstName',
          },
        }),
        maxLengthValidator({
          errorMsgId: 'E0013',
          max: 55,
          params: [
            {
              key: 0,
              value: 'label.firstName',
            },
            {
              key: 1,
              value: 55,
            },
          ],
        }),
      ],
    }),
    lastName: new FormControl<string | null>(null, {
      validators: [
        AswValidators.required({
          errorMsgId: 'E0001',
          params: {
            key: 0,
            value: 'label.lastName',
          },
        }),
        AswValidators.alphaSpace({
          errorMsgId: 'E0004',
          params: {
            key: 0,
            value: 'label.lastName',
          },
        }),
        AswValidators.lengths({
          min: 2,
          errorMsgId: 'E0484',
        }),
        maxLengthValidator({
          errorMsgId: 'E0013',
          max: 55,
          params: [
            {
              key: 0,
              value: 'label.lastName',
            },
            {
              key: 1,
              value: 55,
            },
          ],
        }),
      ],
    }),
  });
};
